import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";

import { ATTACHMENT_TYPES, CHAT_SCREEN_MODE } from "Utils/MessageHelpers";
import { useMessageOptions } from "UIComponents/Message/providers/MessageProvider";

import MediaWrapper, { MEDIA_VISIBILITY } from "../MediaWrapper";
import {
  MEDIA_DIMENSIONS_PER_VIEW_MODE,
  SQUARE_THUMBNAIL_RESOLUTION,
} from "../Utils";
import classes from "./DoubleVisualMediaContainer.scss";

const DoubleVisualMediaContainer = props => {
  const { attachments, onMediaClick } = props;
  const {
    screenMode = CHAT_SCREEN_MODE.VIEW_MODE_SCREEN,
  } = useMessageOptions();

  return (
    <div className={classes.container}>
      {_.map(attachments, attachment => {
        const { id, type } = attachment;
        const isVideo = type === ATTACHMENT_TYPES.VIDEO;

        return (
          <MediaWrapper
            key={id}
            onMediaClick={onMediaClick}
            iconVisibility={isVideo ? MEDIA_VISIBILITY.PERSISTENT : undefined}
            attachment={attachment}
            height={MEDIA_DIMENSIONS_PER_VIEW_MODE[screenMode].height}
            width={MEDIA_DIMENSIONS_PER_VIEW_MODE[screenMode].width}
            imgClassName={classes.image}
            thumbnailResolution={SQUARE_THUMBNAIL_RESOLUTION}
          />
        );
      })}
    </div>
  );
};

DoubleVisualMediaContainer.propTypes = {
  onMediaClick: PropTypes.func.isRequired,
  attachments: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DoubleVisualMediaContainer;
